import { map, clone } from 'lodash';

const endpoint = property => `/api/${property}/events/categories`;
const reconstruct = property => `/api/${property}/events/reconstruct/categories`;

export default ['api', '$rootScope', 'categoriesTransformer', function (api, $rootScope, categoriesTransformer) {
    return {
        save: category => {
            let url = category.id ? `${endpoint(api.property())}/${category.id}` : endpoint(api.property());

            let submit = clone(category);
            if (!submit.id) {
                if (submit.days && submit.days.length) submit.days = map(submit.days, day => day.day.id);
                if (submit.treatments && submit.treatments.length) submit.treatments = map(submit.treatments, treatment => treatment.treatment.id);
            }

            return api.upload(url, submit).then(response => response.data);
        },
        delete: id => api.delete(`${endpoint(api.property())}/${id}`),
        findAll: (page = undefined, perpage = undefined, deleted = undefined) => {
            return api.get(endpoint(api.property()) + (page ? '?page=' + (page) + (page > -1 ? '&perpage=' + (perpage || '20') : '') : '') + (deleted ? '&deleted=true' : '')).
                then(response => response.data);
        },
        findRelated: () => {
            return api.get(`${endpoint(api.property())}?page=-1&related=true`).
                then(response => response.data);
        },
        hierarchyFind: (flatten = null) => {
            return api.get(endpoint(api.property()) + '?page=-1').
                then(response => categoriesTransformer.restructure(response.data, flatten));
        },
        findById: id => {
            return api.get(`${endpoint(api.property())}/${id}`)
                .then(response => response.data);
        },
        reconstruct: categories => {
            return api.post(`${endpoint(api.property())}/reconstruct`, categories)
                .then(response => response.data);
        },
        search: (type, text, page = null, perpage = null) => {
            return api.get(`${endpoint(api.property())}` + (page ? '?page=' + (page) + (page > -1 ? '&perpage=' + (perpage || '20') : '') : '') + `&type=${type}&text=${text}`).then(response => response.data);
        }
    };
}];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/event/services/categories.service.js